export const theme = {
  light: {
    font: "#242B50",
    background: "#F8F9FF",
  },
  dark: {
    font: "#F8F9FF",
    background: "#02061C",
  },
}
